import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported as analyticsIsSupported } from "firebase/analytics";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY!,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN!,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID!,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET!,
  appId: process.env.REACT_APP_FIREBASE_APP_ID!,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID!,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || process.env.REACT_APP_GA4_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

let analytics: ReturnType<typeof getAnalytics> | undefined = undefined;
if (typeof window !== "undefined" && typeof document !== "undefined") {
  analyticsIsSupported().then(supported => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  });
}

export { analytics };

// Emulators are opt-in to avoid accidentally routing localhost sessions to emulated Auth/Functions.
// Set REACT_APP_USE_FIREBASE_EMULATORS=true when intentionally running local Firebase emulators.
const useFirebaseEmulators = process.env.REACT_APP_USE_FIREBASE_EMULATORS === "true";

if (useFirebaseEmulators) {
  // Firestore Emulator
  connectFirestoreEmulator(db, "localhost", 8008);

  // Auth Emulator (disableWarnings avoids noisy console output)
  connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });

  // Functions Emulator
  connectFunctionsEmulator(functions, "localhost", 5001);

  if (process.env.NODE_ENV !== "production") {
    console.info("[firebase] emulators enabled", {
      appName: app.name,
      projectId: app.options.projectId,
      authEmulator: "http://localhost:9099",
      firestoreEmulator: "localhost:8008",
      functionsEmulator: "localhost:5001",
    });
  }
}
